import {MD3LightTheme as DefaultTheme} from 'react-native-paper';

const Colors = {
  ...DefaultTheme.colors,
  primary: '#5553F5',
  secondary: '#7e7f96',
  menuGray: "#838fb9",
  menuDark: "#abb9e8",

  //InputTex
  outLineInputText: '#7e7f96',
  inputTextColor: '#000336',
  inputTextPlaceHolderColor: '#7e7f96',
  labelColor: '#000336',
  headerBlue: '#000336',
  labelErrorColor: '#f06548',

  //CUSTOM
  bgWhite: '#ffffff',
  bgLoginHeader: '#f3f3f9',
  bgLogin: '#38497e',
  bgLoginForm: '#ffffff',
  textWhite: '#ffffff',

  bgBlue: '#000336',
  bgGrayMain: '#f3f3f9',

  statusOpenColor: '#69e4b2',
  statusDraftColor: '#e6ff50',
  statusCloseColor: '#ff6b3e',
  iconGrayColor: '#7e7f96',
  greenButtonColor: '#69e4b2',
  listItemGrey: '#f7f7f7',
  textItemGrey: '#7e7f96',

  grayButton: '#efefef',
  darkGrayButton: '#7e7f96',
  grayTextButton: '#7e7f96',

  orangeIcon: '#ff6b3e',
  blueIconShadow: '#000851',
  transparent: '#ffffff00',

  uploadIconBg: '#7e7f96',
  orangeCardBg: '#ffe1d8',

  grayBG: '#f7f7f7',
  graySeparator: '#7e7f96',
  grayBGDialog: '#efefef',
  blackColor: '#000000',
  // Chat
  black: '#000000',
  lavender: '#ececee',
  eclipse: '#3e3e3e',
  cinder: '#242729',
  malibu: '#55acee',
  whisper: '#eeeeee',
  amaranth: '#E0434C',
  windsor: '#402583',
  ghost: '#bbbdc5',
  snow: '#FBFBFB',

  blueReadonly: "#eff2f7",
  orangeLight: "#fde3de",
  inputTextBackground: "#B6D9FF",
};

export default Colors;
